import HistoricalDocumentTableFooter from '../HistoricalDocumentTableFooter';

import type { Responsive } from 'mui-datatables';

export const getHistoryTableOptions = (docType: string) => ({
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: true,
  fixedHeader: false,
  sort: true,
  download: false,
    responsive: 'standard' satisfies Responsive,
  selectableRows: 'none',
  textLabels: {
    body: {
      noMatch: 'No records found for applied filters, click search to generate list',
    },
  },
  customFooter: (
    rowCount: number,
    page: number,
    rowsPerPage: number,
    changeRowsPerPage: (page: string | number) => void,
    changePage: (newPage: number) => void,
  ) => {
    return (
      <HistoricalDocumentTableFooter
        count={rowCount}
        page={page}
        docType={docType}
        rowsPerPage={rowsPerPage}
        changeRowsPerPage={changeRowsPerPage}
        changePage={changePage}
      />
    );
  },
});
